const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

// Sicherheitsnetz gegen haengengebliebene Einblendungen.
//
// Ein Element mit scroll-trigger steht per CSS auf opacity 0.01 und wird erst
// sichtbar, wenn onIntersection die Klasse scroll-trigger--offscreen entfernt.
// Faellt dieser Durchlauf falsch aus, bleibt der Platz reserviert und der
// Inhalt unsichtbar - genau das Bild "leerer Bereich in richtiger Hoehe".
//
// Der erste Durchlauf laeuft direkt nach DOMContentLoaded, also auf einem
// Layout, das sich danach noch verschiebt: der Browser stellt die
// Scrollposition wieder her, App-Widgets bauen sich spaet auf, verzoegerte
// Sektionen kommen nach. Verschiebt sich dabei alles unter die Sichtkante,
// markiert der Beobachter die halbe Seite als offscreen, und die zugehoerige
// Nachmeldung beim Zurueckscrollen bleibt in dieser Konstellation aus.
//
// Deshalb nach dem load-Event und bei Rueckkehr aus dem bfcache noch einmal
// alles beobachten, was noch als offscreen markiert ist. Ein frischer
// Beobachter misst gegen das inzwischen ruhige Layout und meldet weiterhin
// beim Scrollen nach. Sichtbares wird dadurch nie versteckt: onIntersection
// entfernt die Markierung nur, es setzt sie an bereits markierten Elementen
// hoechstens erneut.
function reobserveStuckAnimationTriggers() {
  const stuck = Array.from(document.getElementsByClassName(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME));
  if (stuck.length === 0) return;

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  stuck.forEach((element) => observer.observe(element));
}

// deferred-sections.js ruft das nach jeder nachgeladenen Sektion auf: dort
// waechst die Seite um mehrere Bildschirmhoehen, was die Sichtbarkeit aller
// noch markierten Elemente veraendert.
window.revealStuckScrollTriggers = reobserveStuckAnimationTriggers;

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

window.addEventListener('load', () => {
  // Ein Frame Abstand, damit die Messung nach dem Layout des load-Zeitpunkts
  // stattfindet und nicht mittendrin.
  requestAnimationFrame(reobserveStuckAnimationTriggers);
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) reobserveStuckAnimationTriggers();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
